'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _reduce2 = require('./internal/_reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Transform the contents of `subject` to `into` by applying `operation` to each
 * item.
 *
 * @example
 * reduce(
 *   List(),
 *   (acc, val) => acc.push(val),
 *   Map({ one: 1, two: 2, three: 3 })
 * );
 * // returns List [ 1, 2, 3 ]
 *
 * @param  {any} into
 * @param  {Function} operation
 * @param  {Iterable} subject   [description]
 * @return {Iterable}
 */
exports.default = (0, _curry2.default)(_reduce3.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.9/reduce.js
// module id = 252
// module chunks = 2 3